import styled, { css } from 'styled-components';

import {
  ButtonBaseProps,
  ButtonBaseStyled,
} from 'approot/shared/styles/buttons/base-button.style';
import { rem, mediaUp } from 'approot/shared/style';
import {
  spacing16,
  spacing20,
  spacing80,
} from 'approot/shared/styles/spacing.style';

type ContainerProps = {
  isVisible: boolean;
  isFluid?: boolean;
  hasLeftNavigation?: boolean;
};

export const ScrollToTopButton = styled.button<
  ContainerProps & ButtonBaseProps
>`
  ${ButtonBaseStyled}

  bottom: ${rem(72)};
  bottom: calc(env(safe-area-inset-bottom) + ${rem(72)});
  left: 50%;
  transform: translateX(-50%);

  position: fixed;
  z-index: 4;

  ${({ isFluid }) =>
    isFluid &&
    `
    position: absolute;
    bottom: ${rem(33)};
  `};

  transition: opacity 500ms 0s, visibility 0s 600ms;

  ${mediaUp.lg`
    bottom: ${rem(spacing80 + spacing20)};
    bottom: calc(env(safe-area-inset-bottom) + ${rem(spacing80 + spacing20)});
  `}

  ${mediaUp.xl`
    bottom: ${rem(spacing80 + spacing16)};
    bottom: calc(env(safe-area-inset-bottom) + ${rem(spacing80 + spacing16)});
  `}

  ${props =>
    props.hasLeftNavigation &&
    !props.isFluid &&
    css`
      ${mediaUp.md`
        left: calc(50% + ${rem(45)});
        left: calc(50% + ${rem(45)} + env(safe-area-inset-left) / 2);
      `}

      ${mediaUp.lg`
        bottom: ${rem(spacing80 + spacing16)};
        bottom: calc(env(safe-area-inset-bottom) + ${rem(
          spacing80 + spacing16
        )});
      `}

      @media (min-width: 1370px) {
        left: calc(50% + ${rem(132)});
        left: calc(50% + ${rem(132)} + env(safe-area-inset-left) / 2);
      }
    `}

  ${props =>
    props.isVisible
      ? `
    opacity: 1;
    visibility: visible;
    transition: opacity 500ms 0s, visibility 0s 0s;
  `
      : `
    opacity: 0;
    visibility: hidden;
  `}
`;
